import styles from './Footer.module.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <p>&copy; {currentYear} Joocha. All rights reserved.</p>
        <p className={styles.tagline}>Powered by modern web technologies</p>
      </div>
    </footer>
  );
}

export default Footer;
